import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ProvedorSessao, useSessao } from "./sessao";
import { Moldura } from "./componentes/Moldura";
import { Entrar } from "./telas/Entrar";
import { EsqueciSenha, RedefinirSenha } from "./telas/SenhaEsquecida";
import { Home } from "./telas/Home";
import { Oportunidades } from "./telas/Oportunidades";
import { Licitacao } from "./telas/Licitacao";
import { AcervoTela } from "./telas/Acervo";
import { Varredura } from "./telas/Varredura";
import { Editais } from "./telas/Editais";
import { AtestadoFicha, Atestados } from "./telas/Atestados";
import { Hoje } from "./telas/Hoje";
import { Extracao } from "./telas/Extracao";
import { Fila } from "./telas/Fila";
import { Vocabulario } from "./telas/Vocabulario";
import { Configuracao } from "./telas/Configuracao";
// A area dev sai inteira daqui: apagar `src/dev/` e esta linha mais a rota
// abaixo. No build `DEV_ATIVO` vira `false` e o empacotador descarta o modulo.
import { DEV_ATIVO, DesignSystem, Dev } from "./dev";

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // O acervo muda quando uma rodada termina, não a cada segundo. Refetch
      // ao focar a janela cobre o caso real: você volta para a aba depois de
      // uma varredura e quer ver o resultado.
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

function Protegido({ children }: { children: React.ReactNode }) {
  const { usuario, carregando } = useSessao();
  if (carregando) return <div className="carregando">Carregando…</div>;
  if (!usuario) return <Navigate to="/entrar" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <QueryClientProvider client={cliente}>
      <BrowserRouter>
        <ProvedorSessao>
          <Routes>
            <Route path="/entrar" element={<Entrar />} />
            {/* A senha esquecida (0143): fora do `Protegido`, porque quem
                chega aqui não consegue entrar. */}
            <Route path="/esqueci-senha" element={<EsqueciSenha />} />
            <Route path="/redefinir-senha" element={<RedefinirSenha />} />
            <Route
              element={
                <Protegido>
                  <Moldura />
                </Protegido>
              }
            >
              <Route path="/" element={<Home />} />
              <Route path="/hoje" element={<Hoje />} />
              <Route path="/oportunidades" element={<Oportunidades />} />
              <Route path="/licitacao/:id" element={<Licitacao />} />
              <Route path="/varredura/:id" element={<Varredura />} />
              <Route path="/extracao" element={<Extracao />} />
              <Route path="/editais" element={<Editais />} />
              <Route path="/atestados" element={<Atestados />} />
              <Route path="/atestados/:codigo" element={<AtestadoFicha />} />
              <Route path="/acervo" element={<AcervoTela />} />
              <Route path="/fila" element={<Fila />} />
              <Route path="/vocabulario" element={<Vocabulario />} />
              <Route path="/configuracao" element={<Configuracao />} />
              {DEV_ATIVO && <Route path="/dev" element={<Dev />} />}
              {DEV_ATIVO && <Route path="/dev/design" element={<DesignSystem />} />}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </ProvedorSessao>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
